import { IInitialState } from "./types";

export const initialState: IInitialState = {
  corporateClients: {},
  corporateClientsByMarathonId: {
    response: {
      loading: false,
      error: null,
      data: null
    }
  },
  corporateClientsByUserId: {},
  corporateClientsExcelByMarathonId: {},
  corporateClientsNamesByMarathonId: {},
  corporateClientsWithVouchersByMarathonId: {},
  isUserResponsibleForCorporateClient: {},
  corporateClientsLookupId: null,
  corporateClientsLookup: {
    params: {
      page: 1,
      pageSize: 10,
      hasMore: true,
      name: null,
      allCorporateClientsLookup: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  }
};
